import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShipmentOrderSpec } from '@core/models/job-file/shipment-order-spec.model';
import { ShipmentOrder } from '@core/models/job-file/shipment-order.model';

@Component({
  selector: 'hmt-job-plan-order-details',
  templateUrl: './job-plan-order-details.component.html',
  styleUrls: ['./job-plan-order-details.component.scss'],
  standalone: false
})
export class JobPlanOrderDetailsComponent {
  @Input() order!: ShipmentOrderSpec;
  @Input() orderSelected: boolean = false;
  @Input() hideCheckboxes: boolean = false;
  @Output() skuSelectionChanged = new EventEmitter<{ selectedCount: number; totalCount: number }>();
  @Output() skuItemSelected = new EventEmitter<{ selected: boolean; order: ShipmentOrder }>();
  @Output() skuQuantityChanged = new EventEmitter<{ order: ShipmentOrder; newQuantity: number }>();

  get visibleShipmentOrders(): ShipmentOrder[] {
    return (this.order?.shipmentOrders || []).filter(sku => sku.show !== false);
  }

  onSelectionChanged(event: { selectedCount: number; totalCount: number }): void {
    this.skuSelectionChanged.emit(event);
  }

  onItemSelected(event: { selected: boolean; order: ShipmentOrder }): void {
    this.skuItemSelected.emit(event);
  }

  onQuantityChanged(event: { order: ShipmentOrder; newQuantity: number }): void {
    // Update the rendered sku directly for immediate display consistency…
    event.order.quantity = event.newQuantity;
    // …and bubble up so the parent persists the edit into the move snapshot.
    this.skuQuantityChanged.emit(event);
  }
}

